import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./contentSection.html";
import { WireI18n } from '~/modules/stores/i18nStore';
class ContentSection extends LightningElement {
  constructor(...args) {
    super(...args);
    this.section = void 0;
    this.filtered = void 0;
  }
  i18nCallback(i18n) {
    this.labels = i18n.learn;
  }
  get posts() {
    return this.section?.hydratedItems?.reduce((accumulator, item) => {
      if (!item.isError && !item.isLoading && item.data) {
        accumulator.push(item.data);
      }
      return accumulator;
    }, []) || [];
  }
  get hasPosts() {
    return this.section?.hydratedItems.length > 0;
  }
  moreClicked(_event) {
    const filterChangeEvent = new CustomEvent('learnfilter', {
      detail: {
        filterType: 'contentType',
        value: this.section.slug
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(filterChangeEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ContentSection, {
  publicProps: {
    section: {
      config: 0
    },
    filtered: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ContentSection, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;